var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-toggle-button"},[_c('div',{staticClass:"plane",style:(_vm.gradientBackgroundStyle),on:{"click":_vm.emitButtonToggled}},[_c('div',{class:_vm.dotClass})])])}
var staticRenderFns = []

export { render, staticRenderFns }